
import entityService from '@/services/entity'

export default class Criteria {

  setClientId(clientId) {
    this._clientId = clientId
    return this
  }
  
  get clientId() {
    return this._clientId
  }
  
  setEntityTypeId(entityTypeId) {
    this._entityTypeId = entityTypeId
    return this
  }
  
  get entityTypeId() {
    return this._entityTypeId
  }

  setEntityId(entityId) {
    this._entityId = entityId
    return this
  }
  
  get entityId() {
    return this._entityId
  }

  getProperties() {
    return []
  }

  async getCustomFields() {
    if (this._entityId) {
      const resp = await entityService.getCustomFieldsByEntityId(this._entityId)
      return resp.data
    }
    const resp = await entityService.getCustomFieldsByEntityType(this._entityTypeId, this._clientId)
    return resp.data
  }
}